import { useEffect, useRef, useState } from "react";
import { Input } from "./ui/input";

/**
 * Simple autocomplete that suggests from `options` (array of strings) as user types.
 * If value is not in options, it will be treated as a new value (categoria criada em runtime).
 */
export default function CategoryAutocomplete({ value, onChange, options = [], placeholder, testid }) {
  const [open, setOpen] = useState(false);
  const [highlight, setHighlight] = useState(0);
  const wrapperRef = useRef(null);

  useEffect(() => {
    const onClick = (e) => {
      if (wrapperRef.current && !wrapperRef.current.contains(e.target)) setOpen(false);
    };
    document.addEventListener("mousedown", onClick);
    return () => document.removeEventListener("mousedown", onClick);
  }, []);

  const q = (value || "").toLowerCase();
  const filtered = options.filter((o) => o.toLowerCase().includes(q)).slice(0, 8);
  const showSuggestions = open && filtered.length > 0;

  return (
    <div className="relative" ref={wrapperRef}>
      <Input
        value={value}
        onChange={(e) => { onChange(e.target.value); setOpen(true); setHighlight(0); }}
        onFocus={() => setOpen(true)}
        onKeyDown={(e) => {
          if (!showSuggestions) return;
          if (e.key === "ArrowDown") { e.preventDefault(); setHighlight((h) => Math.min(h + 1, filtered.length - 1)); }
          else if (e.key === "ArrowUp") { e.preventDefault(); setHighlight((h) => Math.max(h - 1, 0)); }
          else if (e.key === "Enter") {
            if (filtered[highlight]) { e.preventDefault(); onChange(filtered[highlight]); setOpen(false); }
          } else if (e.key === "Escape") setOpen(false);
        }}
        placeholder={placeholder}
        autoComplete="off"
        data-testid={testid}
      />
      {showSuggestions && (
        <div className="absolute z-20 mt-1 w-full bg-white border border-border rounded-md shadow-lg overflow-hidden">
          {filtered.map((opt, i) => (
            <button
              key={opt}
              type="button"
              onMouseDown={(e) => { e.preventDefault(); onChange(opt); setOpen(false); }}
              onMouseEnter={() => setHighlight(i)}
              className={`w-full text-left px-3 py-2 text-sm ${i === highlight ? "bg-[hsl(var(--secondary))]" : ""}`}
              data-testid={`${testid}-option-${i}`}
            >
              {opt}
            </button>
          ))}
        </div>
      )}
    </div>
  );
}
